/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, phrase: NonNullable<unknown> }} Seo_Title_Price_ScraperInputs */

const en_seo_title_price_scraper = /** @type {(inputs: Seo_Title_Price_ScraperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} scraper API pricing - ${i?.phrase}`)
};

const zh_hans1_seo_title_price_scraper = /** @type {(inputs: Seo_Title_Price_ScraperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 数据抓取 API 价格：${i?.phrase}`)
};

const pt_br2_seo_title_price_scraper = /** @type {(inputs: Seo_Title_Price_ScraperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API de scraping para ${i?.name}: preços - ${i?.phrase}`)
};

const es_seo_title_price_scraper = /** @type {(inputs: Seo_Title_Price_ScraperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Precios de la API de scraping de ${i?.name}: ${i?.phrase}`)
};

const fr_seo_title_price_scraper = /** @type {(inputs: Seo_Title_Price_ScraperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tarifs de l’API de scraping ${i?.name} - ${i?.phrase}`)
};

const de_seo_title_price_scraper = /** @type {(inputs: Seo_Title_Price_ScraperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preise der ${i?.name}-Scraper-API: ${i?.phrase}`)
};

const ru_seo_title_price_scraper = /** @type {(inputs: Seo_Title_Price_ScraperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Цены на скрапер-API ${i?.name} - ${i?.phrase}`)
};

const it_seo_title_price_scraper = /** @type {(inputs: Seo_Title_Price_ScraperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prezzi dell'API di scraping ${i?.name} - ${i?.phrase}`)
};

/**
* | output |
* | --- |
* | "{name} scraper API pricing - {phrase}" |
*
* @param {Seo_Title_Price_ScraperInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_title_price_scraper = /** @type {((inputs: Seo_Title_Price_ScraperInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Title_Price_ScraperInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_title_price_scraper(inputs)
	if (locale === "pt-BR") return pt_br2_seo_title_price_scraper(inputs)
	if (locale === "es") return es_seo_title_price_scraper(inputs)
	if (locale === "fr") return fr_seo_title_price_scraper(inputs)
	if (locale === "de") return de_seo_title_price_scraper(inputs)
	if (locale === "ru") return ru_seo_title_price_scraper(inputs)
	if (locale === "it") return it_seo_title_price_scraper(inputs)
	return en_seo_title_price_scraper(inputs)
});